import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from './utils.js';
const Progress = React.forwardRef(({ className, value = 0, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('relative h-4 w-full overflow-hidden rounded-full bg-secondary', className), ...props, children: _jsx("div", { className: "h-full bg-primary transition-all duration-200 ease-in-out", style: { width: `${Math.min(100, Math.max(0, value))}%` } }) })));
Progress.displayName = 'Progress';
export { Progress };
